import type {
  ConfigSection,
  CommunityPreviewDeviceMeta,
  FullBoardConfigData,
} from "@eweadn-qiankun/shared-types";
import CommunityKeyboardPreview from "./CommunityKeyboardPreview";
import CommunityMousePreview from "./CommunityMousePreview";

export interface CommunityConfigPreviewProps {
  deviceCategory: "keyboard" | "mouse";
  meta: CommunityPreviewDeviceMeta;
  activeSection: ConfigSection;
  keyboardConfigData?: FullBoardConfigData;
  mouseConfigData?: Record<string, unknown>;
  /** 0=Win，1=Mac；星闪改键预览仅展示当前系统层 */
  currentDeviceSystem?: number;
}

/** 社区配置详情预览入口（按品类路由到键盘/鼠标预览） */
export default function CommunityConfigPreview({
  deviceCategory,
  meta,
  activeSection,
  keyboardConfigData,
  mouseConfigData = {},
  currentDeviceSystem = 0,
}: CommunityConfigPreviewProps) {
  if (deviceCategory === "keyboard") {
    return (
      <CommunityKeyboardPreview
        meta={meta}
        configData={
          keyboardConfigData ?? {
            lighting: {},
            trigger: [],
            advancedKey: new Map(),
            changeKey: [],
            performance: {},
          }
        }
        activeSection={activeSection}
        currentDeviceSystem={currentDeviceSystem}
      />
    );
  }

  return (
    <CommunityMousePreview
      meta={meta}
      configData={mouseConfigData}
      activeSection={activeSection}
    />
  );
}
